<template>
  <div class="know-list">
    <div class="app-page-wrapper know-list-box">
      <p class="hintContent">
        当前位置：<span @click="toHome" class="crumb-link">首页</span> > <span class="crumb-text">{{ pageName }}</span>
      </p>
      <div class="list-content">
        <el-tabs type="border-card" v-model="activeName" @tab-click="tabClick">
          <el-tab-pane
            v-for="(item, index) in navs"
            :key="index"
            :label="item.name"
            :name="index + ''"
          >
            <ShowList
              :showData="{
                ...item,
                chooseIndex: activeName,
                defaultIndex: index + '',
              }"
              @onNewsClick="onNewsClick"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ShowList from "./list.vue";
import { consultCategory } from '@/utils/global'

export default {
  name: 'UnitConsult',
  components: {
    ShowList
  },
  props: {
    showData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    showData(newValue) {
      this.pageName = newValue.title;
      this.isHiddenFoot = !newValue.isHiddenFoot;
      this.afterIndexChange();
    },
  },
  data() {
    return {
      pageName: '部门资讯',
      activeName: "0",
      navs: consultCategory.know,
      isHiddenFoot:this.showData && !this.showData.isHiddenFoot || false ,
    };
  },
  beforeRouteLeave(to, from, next) {
    console.log(document.getElementsByClassName('el-tabs__nav')[0].style.transform)
    next()
  },
  activated() {
    this.init()
  },
  mounted() {
    this.init();
  },
  methods: {
    afterIndexChange() {
      if (this.showData.chooseIndex === this.showData.defaultIndex) {
        if(this.activeName === '-1'){
          this.activeName = '0'
        }
      }
    },
    init() {
      if (this.$route.query.id) {
        const activeName = this.navs.findIndex(item => item.id === this.$route.query.id) || 0
        this.activeName = activeName + ''
      }
    },
    toHome() {
      this.$router.push('/home');
    },
    onNewsClick(data) {
      this.$router.push({
        path: `/newsDetails/unit/${data.data.id}/${data.catalogId}`,
      });
      // if (this.showData.isHiddenFoot) {
      //   this.$emit("onNewsClick", data);
      // } else {
      // }
    },
    tabClick(tabData) {
      this.activeName = tabData.index;
    },
  },
};
</script>

<style lang="less" scoped>
.know-list {
  width: 100%;
  height: 100%;
  .know-list-box {
    .list-content {
      width: 100%;
      background: #fff;
      padding: 20px;
      /deep/.el-tabs__content {
        margin-top: 16px;
        padding: 0px;
      }
      /deep/.el-tabs--border-card {
        border: 0px;
        box-shadow: unset;
        background: transparent;
      }
      /deep/.el-tabs__header {
        border: 0px;
        background: transparent;
        height: 57px;
      }
      /deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item {
        border: 0px;
        background: transparent;
        color: #333333;
        height: 57px;
        font-size: 20px;
        line-height: 50px;
        text-align: center;
      }
      /deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
        color: #ffffff;
        background: url("~@/assets/knowList/tab-bg.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
